import { jsx as _jsx } from "react/jsx-runtime";
import PageNotFound from 'pages/PageNotFound';
import services from 'services';
import ReceptionDesksList from './List';
var ReceptionDesksPage = function () {
    if (!services.permissionService.hasPermissionToViewReceptionDesks()) {
        return _jsx(PageNotFound, {});
    }
    return _jsx(ReceptionDesksList, {});
};
export default ReceptionDesksPage;
